import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home_cat_buttons1" }
const _hoisted_2 = ["onMouseover", "onMouseleave"]
const _hoisted_3 = { class: "text1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconMenuPreviewDataList, (button) => {
      return (_openBlock(), _createElementBlock("div", {
        key: button.menuId,
        class: _normalizeClass(['button1', { hover: button.hover }]),
        onMouseover: ($event: any) => (button.hover = true),
        onMouseleave: ($event: any) => (button.hover = false)
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['image1', button.hover ? 'hover' : '']),
          style: _normalizeStyle({
          backgroundImage: `url(/WITH_AG_PORTAL/images/${
            button.hover ? button.imageFileOver : button.imageFileNomal
          })`,
          backgroundColor: '#F3F5F9', // 背景色
          backgroundPosition: 'center', // 画像を中央に配置
          backgroundSize: 'cover', // 画像をカバーとして設定
          transition: '0.5s ease',
          transform: button.hover ? 'scale(1.05)' : 'scale(1)', // ホバー時にスケールを変更
        })
        }, null, 6),
        _createElementVNode("span", _hoisted_3, _toDisplayString(button.menuName), 1)
      ], 42, _hoisted_2))
    }), 128))
  ]))
}